export default __webpack_public_path__ + "static/two-young-business-partners-1ffd413c8484baf623a9b6f7ad197484.png";